import { render, staticRenderFns } from "./schoolSet.vue?vue&type=template&id=a7225b4a&scoped=true&"
import script from "./schoolSet.vue?vue&type=script&lang=js&"
export * from "./schoolSet.vue?vue&type=script&lang=js&"
import style0 from "./schoolSet.vue?vue&type=style&index=0&id=a7225b4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7225b4a",
  null
  
)

export default component.exports